module.exports = __webpack_public_path__ + "img/9.ba7f122b.png";